(function () {
  'use strict';
  function items(root, optionIndex) {
    return root.querySelectorAll('[data-swatch-option][data-id="' + optionIndex + '"] [data-swatch-item][data-option-value-id]');
  }
  function label(item) {
    return (item.getAttribute('data-value') || item.textContent || '').trim().toLowerCase();
  }
  function belongsToBrand(model, company) {
    var prefixes = company.split('/').map(function (part) { return part.trim(); }).filter(Boolean);
    return prefixes.some(function (prefix) { return model.indexOf(prefix) === 0; });
  }
  function filterModels(root, company) {
    var allModels = items(root, '1');
    Array.prototype.forEach.call(allModels, function (model) {
      var name = label(model);
      var visible = name.indexOf('nothing phone') !== 0 && belongsToBrand(name, company);
      model.hidden = !visible;
      if (visible) model.style.removeProperty('display');
      else model.style.display = 'none';
      if (name.indexOf('realme ') === 0 || name.indexOf('oneplus ') === 0) {
        model.classList.remove('is--soldout', 'is--unavailable', 'is--disabled', 'disabled');
        model.removeAttribute('aria-disabled');
        model.removeAttribute('disabled');
      }
    });
  }
  function navigate(ids) {
    var url = new URL(window.location.href);
    url.searchParams.delete('variant');
    url.searchParams.set('option_values', ids.join(','));
    window.location.assign(url.toString());
  }
  function selected(root, index) {
    return root.querySelector('[data-swatch-option][data-id="' + index + '"] [data-swatch-item].is--selected[data-option-value-id]');
  }
  function init(root) {
    if (!root || root.dataset.ptHighPickerReady) return;
    root.dataset.ptHighPickerReady = 'true';
    var select = root.querySelector('select[name="id"]');
    var currentId = root.getAttribute('data-current-variant-id');
    if (select && currentId) {
      var option = Array.prototype.find.call(select.options, function (entry) { return entry.value === currentId; });
      if (!option) {
        option = document.createElement('option');
        option.value = currentId;
        option.textContent = 'Selected phone model';
        select.appendChild(option);
      }
      select.value = currentId;
    }
    Array.prototype.forEach.call(items(root, '0'), function (company) {
      if (label(company) === 'nothing') {
        company.hidden = true;
        company.style.display = 'none';
      } else if (label(company) === 'realme' || label(company) === 'oneplus') {
        company.classList.remove('is--soldout', 'is--unavailable', 'is--disabled', 'disabled');
        company.removeAttribute('aria-disabled');
        company.removeAttribute('disabled');
      }
    });
    var activeCompany = selected(root, '0');
    if (activeCompany) filterModels(root, label(activeCompany));
  }
  document.addEventListener('click', function (event) {
    var item = event.target.closest && event.target.closest('[data-swatch-item][data-option-value-id]');
    if (!item) return;
    var option = item.closest('[data-swatch-option][data-id]');
    var root = item.closest('[data-high-variant-picker]');
    if (!root && item.closest('[data-dropdown-wrapper]')) {
      var popup = item.closest('[data-dropdown-wrapper]');
      var opener = document.querySelector('[data-dropdown-open][data-id="' + popup.id + '"]');
      if (opener) root = opener.closest('[data-high-variant-picker]');
    }
    if (!root || !option) return;
    var index = option.getAttribute('data-id');
    var value = label(item);
    if (index === '0') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (value === 'nothing') return;
      var modelOptions = items(root, '1');
      var currentModel = selected(root, '1');
      var model = currentModel && belongsToBrand(label(currentModel), value) ? currentModel :
        Array.prototype.find.call(modelOptions, function (candidate) {
          var name = label(candidate);
          return name.indexOf('nothing phone') !== 0 && belongsToBrand(name, value);
        });
      filterModels(root, value);
      var selection = [item.getAttribute('data-option-value-id')];
      if (model) selection.push(model.getAttribute('data-option-value-id'));
      navigate(selection);
      return;
    }
    if (index === '1') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (value.indexOf('nothing phone') === 0) return;
      var company = selected(root, '0');
      if (!company || !belongsToBrand(value, label(company))) return;
      navigate([company.getAttribute('data-option-value-id'), item.getAttribute('data-option-value-id')]);
    }
  }, true);
  function scan() {
    document.querySelectorAll('[data-high-variant-picker]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
(function () {
  'use strict';
  var selector = '.t4s-swatch__list .t4s-dropdown__wrapper:not(.is-style-mb--false)';
  var pending = false;

  function alignOpenPickers() {
    pending = false;
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var previewBar = document.getElementById('PBarNextFrameWrapper');
    var reserved = previewBar ? previewBar.getBoundingClientRect().height : 0;
    var viewportBottom = window.innerHeight - reserved;

    document.querySelectorAll(selector + '.is--opened').forEach(function (picker) {
      var style = window.getComputedStyle(picker);
      var translateY = style.transform === 'none' ? 0 : new DOMMatrixReadOnly(style.transform).m42;
      var displacement = picker.getBoundingClientRect().bottom - translateY - viewportBottom;
      if (Math.abs(displacement) < 1) return;
      var bottom = parseFloat(style.bottom) || 0;
      picker.style.setProperty('bottom', Math.max(0, bottom + displacement) + 'px', 'important');
    });
  }

  function queueAlignment() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(alignOpenPickers);
  }

  function observe() {
    new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        return change.target.matches && change.target.matches(selector);
      })) queueAlignment();
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
    window.addEventListener('scroll', queueAlignment, true);
    window.addEventListener('resize', queueAlignment);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', queueAlignment);
    queueAlignment();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
